import { apiClient } from './client';
import { MinimumVersionMarkdown, CreateMinimumVersionMarkdownRequest, UpdateMinimumVersionMarkdownRequest, PaginatedResponse } from '../types';

export const minimumVersionMarkdownsApi = {
  getMinimumVersionMarkdowns: async (page = 1, limit = 10, appId?: number): Promise<PaginatedResponse<MinimumVersionMarkdown>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (appId) {
      params.append('app_id', appId.toString());
    }
    return apiClient.get(`/admin/minimum-version-markdowns?${params.toString()}`);
  },

  createMinimumVersionMarkdown: async (markdown: CreateMinimumVersionMarkdownRequest): Promise<MinimumVersionMarkdown> => {
    return apiClient.post('/admin/minimum-version-markdowns', markdown);
  },

  updateMinimumVersionMarkdown: async (appId: number, markdown: UpdateMinimumVersionMarkdownRequest): Promise<MinimumVersionMarkdown> => {
    return apiClient.put(`/admin/minimum-version-markdowns/${appId}`, markdown);
  },

  deleteMinimumVersionMarkdown: async (appId: number): Promise<void> => {
    return apiClient.delete(`/admin/minimum-version-markdowns/${appId}`);
  },
};
